<template>
  <div class="btns">
    <div v-for="(item, idx) in chatButtons" :key="idx" @click="clickedCategory(item, messageType, chatIndex, chat)">
      <a
        v-show="item.type !== 'COUNSELOR_BUTTON' && item.type !== 'URL_BUTTON' && item.type !== 'TEL_BUTTON'"
        :class="{ on: scenarioData[chatIndex] === item.code }"
        :style="{
          color: isRoundCustom ? '#3f5710' : '#2645b6',
          'background-color': isRoundCustom ? '#fdfff4' : '#fafaff'
        }"
      >
        {{ item.url }} {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i
          class="UXicon-arrow_right"
          v-if="item.type === 'LINK_BUTTON'"
          :style="{
            color: isRoundCustom ? '#3f5710' : '#2645b6'
          }"
        ></i>
      </a>

      <a
        v-if="item.type !== 'COUNSELOR_BUTTON' && item.type === 'URL_BUTTON' && item.url"
        :href="item.url"
        target="_blank"
        :class="{ on: scenarioData[chatIndex] === item.code }"
        :style="{
          color: isRoundCustom ? '#3f5710' : '#2645b6',
          'background-color': isRoundCustom ? '#fdfff4' : '#fafaff'
        }"
      >
        {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i
          class="UXicon-link"
          :style="{
            color: isRoundCustom ? '#3f5710' : '#2645b6'
          }"
        ></i>
      </a>

      <a
        v-if="item.type !== 'COUNSELOR_BUTTON' && item.type === 'TEL_BUTTON' && item.callNumber"
        :href="`tel:${item.callNumber}`"
        target="_blank"
        :class="{ on: scenarioData[chatIndex] === item.code }"
        :style="{
          color: isRoundCustom ? '#3f5710' : '#2645b6',
          'background-color': isRoundCustom ? '#fdfff4' : '#fafaff'
        }"
      >
        {{ messageType === 'SCENARIO' ? item.text : item.data }}
        <i
          class="UXicon-call"
          :style="{
            color: isRoundCustom ? '#3f5710' : '#2645b6'
          }"
        ></i>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getHectoRoundList } from '@/constants/customInfo';

export default {
  name: 'ButtonContents',
  props: ['chatIndex', 'messageType', 'clickedCategory', 'chatButtons', 'scenarioData', 'chat'],
  computed: {
    ...mapGetters(['getBrandId']),
    isRoundCustom() {
      return getHectoRoundList().brands.includes(this.getBrandId);
    }
  }
};
</script>
